"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RighteousFuryAbilityHandler = exports.RighteousFuryActorAbilityFactory = exports.RighteousFuryAbilityArgs = void 0;
const AbilityType_1 = require("../../core/abilities/AbilityType");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Duration_1 = require("../../core/Duration");
const core_1 = require("../../core/effects/core");
const MaxAttributeIncrease_1 = require("../../core/effects/core/MaxAttributeIncrease");
const Taunted_1 = require("../../core/effects/core/Taunted");
const AttributeType_1 = require("../../core/enums/AttributeType");
const Registries_1 = require("../../core/state/Registries");
class RighteousFuryAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.RighteousFury;
        this.__typeName = "RighteousFury";
    }
}
exports.RighteousFuryAbilityArgs = RighteousFuryAbilityArgs;
let RighteousFuryActorAbilityFactory = class RighteousFuryActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("RighteousFury", "Self", 4);
    }
};
RighteousFuryActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("RighteousFury")
], RighteousFuryActorAbilityFactory);
exports.RighteousFuryActorAbilityFactory = RighteousFuryActorAbilityFactory;
let RighteousFuryAbilityHandler = class RighteousFuryAbilityHandler {
    init(sequence, container, actorId) { }
    activate(sequence, container, ability) {
        const durationModifier = container.hasAttribute(ability.invokerId, "Charm_Avenger_0") ? 2
            : 0;
        container.applyAbilityAnimation({
            sequence,
            animatedId: ability.invokerId,
            abilityKey: ability.args.__typeName,
            fallback: "casting",
            onAnimated(sequence) {
                container.applyBuff({
                    creatorId: ability.invokerId,
                    targetId: ability.invokerId,
                    duration: Duration_1.Duration.Turns(4 + durationModifier),
                    effect: new core_1.LinkedEffectsEffectArgs([
                        new MaxAttributeIncrease_1.MaxAttributeIncreaseEffectArgs(AttributeType_1.AttributeType.Power, container.getPercentOfBaseAttributeScore(ability.invokerId, 4, "Power")),
                        new core_1.EffectOnHitEffectArgs("Furious", "Taunts on hit", 50, new Taunted_1.TauntedEffectArgs(), Duration_1.Duration.Turns(2))
                    ], false),
                    sequence: sequence.pushSequence("sequential"),
                });
            },
        });
    }
};
RighteousFuryAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.RighteousFury)
], RighteousFuryAbilityHandler);
exports.RighteousFuryAbilityHandler = RighteousFuryAbilityHandler;
